var app = angular.module('leonardo');

var HelpDirective = function(ConfigThemeService) {
  return {
    restrict: 'C',
    scope: {
      helpColor: '@'
    },
    link: function (scope, element) {

      scope.setColor = function() {
        var color = scope.helpColor ? ConfigThemeService.getColor(scope.helpColor) : ConfigThemeService.getColor('warningColor');
        element.css('background-color', color);
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('help', ['ConfigThemeService', HelpDirective]);
